import * as React from "react";
import { Stack } from "@chakra-ui/react";

import { ReactFCC } from "src/types/types";

const InfoBanner: ReactFCC<{ icon: JSX.Element }> = ({ icon, children }) => (
  <Stack
    direction="row"
    py="8px"
    px="16px"
    borderWidth="1px"
    borderColor="ud-grey-300"
    borderRadius="6px"
    align="center"
    spacing="16px"
    bg="ud-grey-100"
  >
    <Stack p="10px" borderRadius="100%" bg="ud-primary-250">
      {icon}
    </Stack>
    {children}
  </Stack>
);

export default InfoBanner;
